// Convert connector end style string to number (shared between whiteboard and SVG)
export const getConnectorEndStyleNumber = (style: string): number => {
  switch (style) {
    case 'none':
      return 0;
    case 'pointyArrow':
      return 10;
    case 'filledArrow':
      return 20;
    case 'filledCircle':
      return 30;
    default:
      return 0;
  }
};

// Convert connector end style number to SVG marker type
export const getConnectorEndStyleSvg = (styleNumber: number): string => {
  switch (styleNumber) {
    case 0:
      return 'none';
    case 10:
      return 'pointy-arrow';
    case 20:
      return 'filled-arrow';
    case 30:
      return 'filled-circle';
    default:
      return 'none';
  }
};
